export const STEPS_FOR_EDGE_CASE = 13;
export const IN_PROGRESS_STATUS = "IN_PROGRESS";
export const SUBMITTED_STATUS = "SUBMITTED";
export const ON_HOLD_STATUS = "ON_HOLD";
export const SKIPPED_STATUS = "SKIPPED";
export const NOT_STARTED_STATUS = "NOT_STARTED";
export const SENT_BACK_STATUS = "SENT_BACK";
export const LEFT = "left";
export const RIGHT = "right";
export const FIXED = "FIXED";
export const ENTER = "Enter";
export const TAB = "tab";
export const ARROW_LEFT = "ArrowLeft";
export const ARROW_RIGHT = "ArrowRight";
export const ORGANIZATIONS_API_ERROR = "organizationsApiError";
export const PROGRAMS_API_ERROR = "programsApiError";
export const COURSES_API_ERROR = "coursesApiError";
export const STATS_API_ERROR = "statsApiError";
